import { SlotGameType1_3 } from "../SlotGameType1_3";

export class TikiBayClassic3 extends SlotGameType1_3
{
}
